import React from 'react'
import { useTranslation } from 'react-i18next'
import { CLOCK_AND_CALENDAR_URL } from 'src/config/imageUrls'
import { useDateFnsLocale } from '@hooks/useDateFnsLocale'
import { useAppointmentCalendar } from '@context/AppointmentCalendarContext/AppointmentCalendarContext'
import { getImageUrl } from 'src/utils/getImageUrl'
import useStyles from './EmptyPeriodMsg.styles'
import { getDateStr } from './helpers/getDateStr'

interface Props {
  clinicId: string
}

const EmptyPeriodMsg = ({ clinicId }: Props) => {
  const { t } = useTranslation()
  const classes = useStyles()
  const { goToPeriodWithNextAvailableSlot, getDayWithNextAvailableSlot } = useAppointmentCalendar()
  const locale = useDateFnsLocale()
  const dayWithNextAvailableSlot = getDayWithNextAvailableSlot(clinicId)
  const dateStr = getDateStr(locale, dayWithNextAvailableSlot)

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <div className={classes.imageContainer}>
          <img src={getImageUrl({ src: CLOCK_AND_CALENDAR_URL })} alt="clock and calendar" className={classes.image} />
        </div>
        <div className={classes.textContainer}>
          <span className={classes.message}>{t('empty_week_label')}</span>
          {dayWithNextAvailableSlot && (
            <span onClick={() => goToPeriodWithNextAvailableSlot(clinicId)} className={classes.link}>
              {t('empty_week_button_label', { day_of_next_available_appointment: dateStr })}
            </span>
          )}
        </div>
      </div>
    </div>
  )
}

export default EmptyPeriodMsg
